/*
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-10-29 13:58:43
 * @LastEditors: liyunfei 3090384495@qq.com
 * @LastEditTime: 2026-04-01 18:37:38
 */
import arLocale from 'element-ui/lib/locale/lang/ar'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: "تحليل تقرير AI",
        train: "خطة التدريب",
        loading: "جاري التحميل...",
        loadingError1: "تعذر التحميل",
        loadingError2: "عذراً، حاول مرة أخرى",
    },
    // 登录页面
    login: {
        loginAndRegister: 'التسجيل / تسجيل الدخول',
        registerAndLogin: 'تسجيل الدخول/تسجيل',
        userLogin: 'تسجيل دخول المستخدم',
        title: 'حسابات الهاتف والبريد الإلكتروني مستقلة عن الآخر، يرجى ملاحظة نوع حسابك.',
        mobileLogin: 'الهاتف',
        emailLogin: 'البريد الإلكتروني',
        email: 'البريد الإلكتروني',
        loginBtn: 'تسجيل الدخول',
        autoLogin: 'تسجيل الدخول تلقائيا في المرة القادمة',
        retransmission: '{item}إعادة الإرسال بعد ثوان',
        formList: [
            {
                label: 'يرجى إدخال رقم هاتفك المحمول',
                placeholder: 'الحصول على رمز التحقق',
            },
            {
                label: 'رمز التحقق',
                placeholder: 'يرجى إدخال رمز التحقق',
            },
            {
                label: 'يرجى إدخال البريد الإلكتروني',
            },
        ],
        btn: {
            submit: 'إنشاء حساب جديد',
            title: 'المعلومات الأصلية مهمة جدا، يرجى تعبئتها بعناية',
        },
        rule: {
            phone: {
                requiredMsg: 'صيغة رقم الهاتف المحمول غير صحيحة',
                patternMsg: 'لم يكن رقم هاتفك مسجلا، يرجى إنشاء الحساب الجديد',
            },
            authCode: {
                requiredMsg: 'رمز التحقق غير صحيح، يرجى إعادة تعبئته',
            },
            email: {
                requiredMsg: 'صيغة صندوق البريد غير صحيحة',
                patternMsg: 'لم يكن البريد الإلكتروني مسجلا، يرجى إنشاء حساب جديد',
            },
        },
        codeSuccess: 'تم إرسال رمز التحقق، يرجى فحصه',
        success: 'تم الإرسال بنجاح',
        error: 'فشل الإرسال',
        loginSuccess: 'تم تسجيل الدخول بنجاح',
        account: {
            accountTitle: 'تسجيل الدخول',
            registerTitle: 'تسجيل الدخول',
            resetTitle: 'تعيين كلمة المرور',
            password: 'كلمة المرور',
            placeholder: 'الرجاء إدخال كلمة المرور',
            codeLogin: 'تسجيل الدخول باستخدام رمز التحقق',
            accountLogin: 'تسجيل الدخول باستخدام كلمة المرور',
            forgotPassword: 'هل نسيت كلمة المرور؟',
            registerTips:[
                'ليس لديك حساب؟', 
                'تسجيل الدخول', 
                'الحساب موجود بالفعل',
                'إنشاء حساب',
            ],
            checkRule: [
                'من 8 إلى 20 حرفًا',
                'يجب أن يحتوي على حرف كبير واحد على الأقل',
                'يجب أن يحتوي على حرف صغير واحد على الأقل',
                'يجب أن يحتوي على رقم واحد على الأقل', 
                'كلمات المرور غير متطابقة'
            ],
            errorTips: [
                'كلمة المرور خاطئة', 
                'فشل في تسجيل الدخول', 
                'الحساب غير موجود'
            ],
            reset:[
                'إعادة تعيين كلمة المرور', 
                "التالي",
                'لا يمكن أن تكون كلمة المرور الجديدة هي نفسها كلمة المرور السابقة', 
                'تخطي',
                'تم تعيين كلمة المرور بنجاح'
            ],
            setPasswordTips:'يجب أن تتكون كلمة المرور من 8 إلى 20 حرفًا، ويجب أن تحتوي على أحرف كبيرة وأحرف صغيرة وأرقام.',
            confirmPassword: "تأكيد كلمة المرور",
        },
        switchButton: 'تسجيل الدخول بكلمة المرور',
        switchButton1: 'تسجيل الدخول باستخدام رمز التحقق',
        loginTips: 'سيتم تسجيل الحسابات غير المسجلة تلقائيًا عند تسجيل الدخول بنجاح.',
        otherLogin: 'طرق تسجيل الدخول الأخرى',
        newEmailLogin: 'تسجيل الدخول بالبريد الإلكتروني',
        newPhoneLogin: 'رقم تسجيل الدخول',
        bindLineTips:'أو',
        bindEmail: 'تسجيل الدخول بالبريد الإلكتروني المربوط',
        bindPhone: 'تسجيل الدخول برقم الهاتف المربوط',
        bindAndContinue: "الربط والمتابعة",
        bind: "ربط",
        bindEmailTitle: 'ربط البريد الإلكتروني',
        bindEmailTips1: "تعذر الحصول على معلومات البريد الإلكتروني الخاصة بـ {item}",
        bindEmailTips2: "يرجى ربط البريد للمتابعة",
        bindEmailTips3: "حسابك غير مرتبط ببريد. بعد الربط يمكنك الدخول واستعادة كلمة السر.",
        boundTitle: 'هل سجلت من قبل؟',
        boundCenterTitle1:'إذا كنت مستخدمًا جديدًا',
        boundCenterTips1:'يمكنك إنشاء حساب والبدء',
        boundCenterTitle2:'إذا كان لديك حساب بالفعل',
        boundCenterTips2:'اربط حسابًا موجودًا لمزامنة البيانات السابقة',
        boundCenterTips3:'يُرجى ربط حساب مُسجَّل',
        boundCenterTips4:'مقترح',
        boundCenterTips5:'ربط حساب {item} بحساب حالي',
        boundCenterTips6:'ستتم مزامنة البيانات والتقارير تلقائيًا',
        boundButton1: 'إنشاء حساب باستخدام {item}',
        boundButton2: 'ربط حساب حالي',
        phoneCode:"الدخول برمز الهاتف",
        phonePassword:"الدخول بكلمة سر الهاتف",
        emailCode:"الدخول برمز البريد",
        emailPassword:"الدخول بكلمة سر البريد",
         accountDoesNotExist:"هذا الحساب غير مسجل بعد. يرجى إتمام التسجيل باستخدام رمز التحقق عبر البريد الإلكتروني أو عبر {item}",
        toRegister:"إنشاء حساب",
        bindNow: "ربط الآن",
        bindError:[
            'فشل الربط',
            'تم فك الربط بنجاح',
            'فشل إلغاء الربط',
            'فشلت المصادقة',
            'فشلت المصادقة، تعذر الحصول على معلومات الحساب',
            'تم الربط بنجاح',
            'الحساب غير موجود. يرجى ربط حساب مسجل.',
            'فشل الربط. هذا الحساب مرتبط بالفعل بحساب {item} [{nickname}].',
            'تم التفويض والتسجيل كحساب، لا يمكن إلغاء الربط',
            'الحساب غير موجود، يُرجى استخدام رمز التحقق لتسجيل الدخول والتسجيل',
        ],
        accountSecurity: {
            faceBook:'حساب فيسبوك',
            google: 'حساب جوجل',
            isBind: 'غير مربوط',
            dialogTitle: 'تأكيد فك الربط؟',
            dialogCenter: 'بعد فك ربط {item}، لن تتمكن بعد ذلك من استخدامه لتسجيل الدخول إلى هذا الحساب.',
            bindFailure:'فشل الربط',
            bindFailureTips: 'حساب {item} الخاص بك مرتبط بالفعل بالحساب أدناه. إذا كنت ترغب في تبديل الربط إلى الحساب الحالي، يرجى تسجيل الدخول إلى الحساب أدناه لفك ربطه أولاً.',
            returnButton:'تأكيد وعودة'
        },
        bindEmailError: [
            "البريد موجود، يرجى استخدام آخر."
        ],

    },
    // 注册页面
    register: {
        mobileRegister: 'تسجيل الهاتف المحمول',
        emailRegister: 'تسجيل البريد الإلكتروني',
        enroll: 'رقم الهاتف المحمول مسجل',
        enrollEmail: 'البريد الإلكتروني مسجل',
        search: 'بحث',
        title: 'حسابات الهاتف والبريد الإلكتروني مستقلة عن الآخر، يرجى ملاحظة نوع حسابك.',
        needRead: {
            agree: 'لقد قرأت ووافقت',
            privacy: 'سياسة خصوصية المستخدم',
        },
        register: 'تسجيل',
        check: 'ضع علامة على "اتفاقية خصوصية المستخدم"',
        newUser: 'تسجيل المستخدم الجديد',
        form: {
            labelList: ['اسم', '*الجنس', '*طول القامة', '*العمر'],
        },
        placeholder: ['يرجى إدخال اسم', 'يرجى إدخال قامتك', 'يرجى إدخال عمرك'],
        unit: ['وحدات مترية', 'وحدات القياس الإمبراطورية ', 'سنة'],
        sexOptions: {
            male: 'ذكر',
            female: 'أنثى',
        },
        btn: 'تقديم',
        rules: {
            metricheight: ['نطاق القامة المسموح بقياسه هو 2 قدم 3 بوصة - 6 أقدام و7 بوصات، يرجى إعادة الإدخال'],
            heightMsg: ['نطاق القامة المسموح بقياسه هو 70-200 سم، يرجى إعادة الإدخال'],
            ageMsg: ['الفئة العمرية المسموح بها 10-99 سنة، يرجى إعادة الإدخال'],
            agePointMsg: ['تم ملء الأعداد غير المدوّرة: يمكن أن يكون العمر عددا مدوّرا فقط، يرجى ملء العمر الصحيح'],
        },
        success: 'تم التسجيل بنجاح',
        userMessage: 'يرجى إدخال اسم المستخدم',
        verify: 'يرجى إدخال رمز التحقق المكون من 4 أرقام',
        errorMsg: 'لا تدعم صيغة القامة المسموح بإدخالها الكسور العشرية، لذا يرجى إعادة إدخالها',
        abnormalMsg: 'التسجيل غير طبيعي',
    },
    // 模型合成
    model: {
        loading: 'جاري إنشاء النموذج، لذا يرجى الانتظار',
        modelLoading: 'جاري تحميل النموذج...',
        tabPane: [
            {
                title: 'تقنية الحس الحقيقي العميق',
                msg: 'من خلال المسح ثلاثي الأبعاد يتم التقاط تفاصيل الجسم بدقة، لضمان قياسات دقيقة وتوضيح التغييرات بعد التمرين.',
            },
            {
                title: 'خوارزمية BDA لتركيب الجسم',
                msg: 'تستخدم Visbody نظام BDA المتقدم لتحديد تركيب الجسم، مما يوفر تقييماً دقيقاً لحجم الجسم لتقييم مخاطر السمنة.',
            },
            {
                title: 'العوامل التي تسببت في الأخطاء',
                msg: 'الملابس الفضفاضة أو بعض الزخارف على / في الجسم سوف تسبب أخطاء، يرجى ارتداء الملابس المشدة أو تقليل كمية الملابس على جسمك إذا كنت ترغب في الحصول على البيانات الأكثر دقة.',
            },
            {
                title: 'مدخل التقرير',
                msg: 'يوصى بوضع إشارة مرجعية على صفحة الموقع حتى تتمكن من عرض التقرير لاحقا، يمكنك أيضًا إرسال هذا التقرير إلى صندوق البريد الخاص بك لاحقا.',
            },
        ],
        collect: ['يرجى وضع إشارة مرجعية على صفحة الموقع،', 'حتى تتمكن من عرض التقرير لاحقا'],
        know: 'أنا معلوم',
        reminder: [
            'النصائح',
            'تم إنشاء نموذج 3D الخاص بك، حاول التمرير إلى اليسار واليمين لتدوير النموذج.',
            'تم إنشاء تقريرك ويمكن عرضه بنقر الزر "عرض التقرير".',
            'لم ينجح تقييم وضعية جسمك، يرجى مراجعة تقرير تكوين الجسم.',
            'لم ينجح تكوين جسمك، يرجى مراجعة تقرير تقييم وضعية الجسم.',
            'القياس الخاص بك غير ناجح، يرجى الانتقال إلى الجهاز لإعادة تجربته~',
            'تكوين الجسم غير ناجح، يرجى الانتقال إلى الجهاز لإعادة تجربته~',
            'لم ينجح تقييم وضعية الجسم، يرجى الانتقال إلى الجهاز لإعادة تجربته~',
        ],
        btn: {
            viewReport: 'عرض التقرير',
            bodyReport: 'عرض تقرير تكوين الجسم',
            postureReport: 'عرض تقرير وضعية الجسم',
            lastReport: 'عرض التقرير الأخير',
            loading: 'جاري التحميل...',
        },
    },
    // 报告
    report: {
        btn: {
            download: 'تنزيل التقرير',
            send: 'إرسال تقرير',
            report: 'تقرير',
        },
        reportSuccess: 'تم إنشاء التقرير بنجاح',
        tabPane: {
            labelList: ['وقت القياس', 'عناصر القياس', 'تكوين الجسم', 'تقييم وضعية الجسم', 'وظيفة الكتف'],
        },
        sendEmail: 'إرسال إلى البريد الإلكتروني:',
        requiredMsg: 'يرجى إدخال البريد الإلكتروني الخاص بك',
        patternMsg: 'يرجى إدخال البريد إلكتروني الصحيح',
        send: 'إرسال',
        download: 'تنزيل التقرير',
        sendReport: 'إرسال تقرير',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: 'تم تعديل الجنس بنجاح',
            height: 'تم تعديل القامة بنجاح',
            age: 'تم تعديل العمر بنجاح',
        },
        logOut: 'تسجيل الخروج',
        personal: 'المركز الشخصي',
        cut: 'تغيير الوحدات / اللغات',
        changeSort: 'تبديل تقرير المنتج',
        setPassword: 'تعيين/تعديل كلمة المرور',
        accountSecurity: 'الحساب والأمان',
        describe: '* بعد تبديل الطراز، ستظهر جميع التقارير.',
        describeBtn: 'بعد تبديل طراز المنتج، ستتم إعادة توجيهك إلى أحدث تقرير قياس ضمن هذا الطراز.',
        descReport: 'تم تبديل تقرير المنتج بنجاح',
        unit: ['النظام المتري (كجم، سم)', 'النظام الإمبراطوري (قدم، انش، رطل)'],
        read: {
            reading: 'قراءة ',
            privacy: 'اتفاقية خصوصية المستخدم',
        },
        setting: 'إعدادات',
        form: {
            labelList: ['رقم الهاتف', 'وحدات', 'اللغات', 'لقب', 'الجنس', 'القامة', 'العمر'],
        },
        placeholder: ['تعديل الاسم', 'تعديل الجنس', 'تعديل القامة', 'تعديل العمر'],
        btn: {
            cancelBtn: 'إلغاء',
            accomplishBtn: 'إكمال',
            confirmBtn: 'تأكيد',
        },
        dialog: [
            'الجنس هو أحد القواعد المهمة لقياس تكوين الجسم، ستكون البيانات المقاسة بعد التعديل مختلفة عن البيانات السابقة. يرجى تأكيد ما إذا كنت تريد تغييره؟',
            'القامة هي إحدى القواعد المهمة لقياس تكوين الجسم، ستكون البيانات المقاسة بعد التعديل مختلفة عن البيانات السابقة. يرجى تأكيد ما إذا كنت تريد تغييره؟',
            'العمر هو أحد القواعد المهمة لقياس تكوين الجسم، ستكون البيانات المقاسة بعد التعديل مختلفة عن البيانات السابقة. يرجى تأكيد ما إذا كنت تريد تغييره؟',
        ],
        rules: {
            metricheight: ['يرجى ملء القامة ضمن النطاق (2 قدم 3 انش - 6 أقدام و 7 انش)'],
            heightMsg: ['يرجى ملء القامة ضمن النطاق (70-200 سم)'],
            ageMsg: [
                'يرجى ملء الفئة العمرية (10-99 سنة)',
                'يتم ملء الأعداد غير المدوّرة: يمكن أن يكون العمر عددا مدوّرا فقط، يرجى ملء العمر الصحيح',
            ],
        },
        heightMsg: 'يرجى إعادة تحديد القامة',
        ageMsg: 'يرجى إعادة تحديد العمر',
        ModelBinding: 'يبدو أن شخصا ما قد قام بمسح الرمز ضوئيا بالفعل، يرجى إعادة القياس!',
        ReportEmpty: {
            title: 'ليس لديك تقرير الاختبار حتى الآن',
            desc: 'تعال إلى الماسح الضوئي للجسم Visbody 3D وقم باتخاذ القياس!',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: 'يبدو أن شخصا ما قد قام بمسح الرمز ضوئيا بالفعل، يرجى إعادة القياس!',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: 'ليس لديك تقرير الاختبار حتى الآن',
        desc: 'تعال إلى الماسح الضوئي للجسم Visbody 3D وقم باتخاذ القياس!',
        descS30: '找到 Visbody-S30 3D 体测精灵，进行一次测量吧！',
        descM30: '找到 Visbody-M30 3D 体测精灵，进行一次测量吧！',
    },
    // 用户信息
    userInfo: {
        height: 'القامة:',
        age: 'العمر:',
        unit: 'سنة',
        weight: 'الوزن',
    },
    // 体成分
    mass: {
        title: 'النظرة العامة على تقييم تكوين الجسم',
        titles: 'تكوين الجسم',
        springFrame: '',
        massFrame: 'لا توجد بيانات القياس لليوم',
        contrast: 'يرجى اختيار تقرير واحد للمقارنة',
        contrastReport: 'يرجى اختيار تقرير واحد للمقارنة',
        noRecord: 'لا توجد سجلات',
        score: 'نقاط',
        status: 'حالة تكوين جسمك الحالية',
        WT: 'الوزن',
        PBF: 'نسبة مؤوية لدهون الجسم',
        endSymbol: '،',
        // 测量相关
        measure: {
            value: 'قيمة القياس',
            standardRange: 'النطاق المعياري',
            comparedWithLastLime: 'مقارنة بالسابق',
            comparedNet: 'مقارنة بالسابق',
            current: '本次测量分数',
            WT: 'الوزن',
            FFM: 'كتلة الجسم اللادهنية',
            BFM: 'كتلة دهون الجسم',
            LM: 'كتلة العضلات',
            TBW: 'مياه الجسم',
            SM: 'العضلة الهيكلية',
            PROTEIN: 'بروتين',
            TM: 'أملاح غير عضوية',
            BMR: 'معدل الأيض الأساسي',
            WHR: 'نسبة الخصر إلى الورك',
            BMI: 'مؤشر كتلة الجسم',
            PBF: 'نسبة الدهون في الجسم',
            VFG: 'مستوى الدهون الحشوية',
            unit: 'كجم',
            BMRUnit: 'كيلو كالوري/ اليوم',
        },
        // 定义解读
        explain: [
            {
                title: 'الوزن',
                msg: 'الوزن هو مجموع الماء في الجسم، البروتين، الملح غير العضوي ووزن الجسم.',
            },
            {
                title: 'كتلة الجسم اللادهنية',
                msg: 'كتلة الجسم اللادهنية هي إجمالي وزن الجسم بدون الدهون',
            },
            {
                title: 'كتلة دهون الجسم',
                msg: 'الدهون في الجسم هي مجموع الدهون تحت الجلد والدهون الحشوية ودهون العضلات.',
            },
            {
                title: 'كتلة العضل',
                msg: 'الكتلة اللادهنية الناعمة هي كتلة الجسم اللادهنية، والتي تشمل العضل الهيكلي، العضلات الملساء وعضلة القلب.',
            },
            {
                title: 'مياه الجسم',
                msg: 'معظم جسم الإنسان عبارة عن ماء بنسبة 50٪ -70٪ من وزن الجسم. وتتواجد مياه الجسم بشكل رئيسي في الخلايا البشرية وسوائل الجسم، ومعظمها موجود في خلايا العضلات.',
            },
            {
                title: 'العضلة الهيكلية',
                msg: 'العضلات الهيكلية، والمعروفة أيضاً باسم العضلات المخططة، هي نوع من العضلات المرتبطة بالعظام. تحتوي البيانات على كمية العضلة الهيكلية.',
            },
            {
                title: 'بروتين',
                msg: 'البروتين مادة صلبة مع الأمونيا الموجودة في جميع خلايا جسم الإنسان. وهو المكون الرئيسي لكتلة العضلات.',
            },
            {
                title: 'أملاح غير عضوية',
                msg: 'يتكون جسم الإنسان من مادة عضوية ومواد غير عضوية وماء. المادة غير العضوية هنا هي أملاح غير عضوية تشكل 5٪ من وزن الجسم.',
            },
            {
                title: 'معدل الأيض الأساسي',
                msg: 'الأيض الأساسي هو إجمالي الطاقة المستهلكة في اليوم عندما يكون الجسم في حالة راحة، بدون تأثير التمارين الرياضية، والأشياء البدنية، والعصبية، والتغيرات الخارجية في درجة الحرارة، وما إلى ذلك.',
            },
            {
                title: 'نسبة الخصر إلى الورك (WHR)',
                msg: 'نسبة الخصر إلى محيط الورك، هي مؤشر مهم لتحديد السمنة المركزية.',
            },
            {
                title: 'مؤشر كتلة الجسم (BMI)',
                msg: 'يستخدم مؤشر كتلة الجسم (BMI ) بشكل أساسي لتقييم مظهر السمنة ، وهو معيار شائع لقياس السمنة في الجسم.',
            },
            {
                title: 'نسبة الدهون في الجسم (BFP)',
                msg: 'نسبة الدهون في الجسم (BFP) هي قياس تكوين الجسم ويحدد كمية الدهون من وزن الجسم.',
            },
            {
                title: 'مستوى الدهون الحشوية',
                msg: 'مستوى الدهون الحشوية هي مؤشر مهم لتقييم ما إذا كانت السمنة الخفية.',
            },
            {
                title: 'السائل داخل الخلايا',
                msg: 'السائل داخل الخلايا: هو سائل الجسم الموجود في خلايا الجسم ككل وهو مكون أساسي للبروتوبلازم.',
            },
            {
                title: 'السائل خارج الخلية',
                msg: 'السائل خارج الخلية: يشير عادةً إلى سوائل الجسم الموجودة خارج الخلية، بما فيها البلازما والسائل الخلالي بين الأوعية الدموية وخلايا الأنسجة.',
            },
            {
                title: 'العمر الأيضي',
                msg: 'يشير العمر الأيضي إلى أداء الجسم ووظائفه الصحية المتعلقة بالتمثيل الغذائي.',
            },
            {
                title: 'نسبة ECW/TBW',
                msg: 'نسبة ECW/TBW هي نسبة الماء خارج الخلية (ECW) إلى إجمالي ماء الجسم (TBW). وهي مؤشر مهم لتقييم توازن سوائل الجسم.',
            },
        ],
        // 节段
        segment: {
            fat: 'الدهون الجزئية',
            muscle: 'العضلات الجزئية',
            right: 'يمين',
            left: 'يسار',
            standard: 'معيار',
            lowStandard: 'معيار منخفض',
            superStandard: 'معيار عال',
            peel: '(الوزن الفارغ)',
        },
    },
    // 体态
    shape: {
        title: 'النظرة العامة على تقييم وضعية الجسم',
        titles: 'تقييم وضعية الجسم',
        status: 'حالتك البدنية الحالية',
        suggest: 'اقتراح',
        possibility: '، تواجد',
        models: {
            front: 'الوجه الأمامي',
            left: 'الجانب الأيسر',
            right: 'الجانب الأيمن',
            top: 'الوجه الخلفي',
            low: 'منخفض قليلا',
            high: 'مرتفع قليلا',
            normal: 'عادي',
        },
        item: {
            deviate: 'قيمة القياس',
            result: 'تعليمات',
            normal: 'عادي',
			keAbnormal: 'احتمال وجود حالة غير طبيعية',
            abnormal: 'غير عادي',
            head: 'وضعية الرأس للأمام',
            headSlant: 'انحناء الرأس',
            roundShoulderLeft: 'كتفين مستديرين لليسار',
            roundShoulderRight: 'كتفين مستديرين لليمين',
            highLowShoudler: 'كتفين غير مستويين',
            pelvis: 'انحناء الحوض الأمامي/الخلفي',
            leftKneeCheck: 'تقييم الركبة اليسرى',
            rightKneeCheck: 'تقييم الركبة اليمنى',
            leg: 'نوع الساق',
            leftLeg: 'الساق اليسرى:',
            rightLeg: 'الساق اليمنى:',
        },
        // 定义解读
        explain: [
            {
                title: 'وضعية الرأس للأمام',
                msg: 'الزاوية بين نقطة الأذن اليسرى والخط الذي يربط مركز الرقبة والخط المتوسط على الجانب.',
            },
            {
                title: 'انحناء الرأس',
                msg: 'الزاوية بين نقطة منتصف الرأس الأمامي ومركز الرقبة والخط المتوسط للجبهة.',
            },
            {
                title: 'كتفين مستديرين لليسار',
                msg: 'الزاوية بين الخط الذي يربط أعلى نقطة على الجانب الأيسر من الظهر وخط الظل للكتف.',
            },
            {
                title: 'كتفين مستديرين لليمين',
                msg: 'الزاوية بين الخط الذي يربط أعلى نقطة على الجانب الأيمن من الظهر وخط الظل للكتف.',
            },
            {
                title: 'كتفين غير مستويين',
                msg: 'المسافة بين النقاط الأخرمية اليسرى واليمنى على الظهر في الاتجاه الرأسي.',
            },
            {
                title: 'انحناء الحوض الأمامي/الخلفي',
                msg: 'زاوية الخط المكون من ثلاث نقاط الذي يربط النقطة المركزية للرقبة ونقطة الورك والكاحل على الجانب الأيسر.',
            },
            {
                title: 'تقييم الركبة اليسرى',
                msg: 'زاوية الخط المكون من ثلاث نقاط لنقطة الورك اليسرى للوجه ومفصل الركبة ونقطة الكاحل.',
            },
            {
                title: 'تقييم الركبة اليمنى',
                msg: 'زاوية الخط المكون من ثلاث نقاط لنقطة الورك اليمنى للوجه ومفصل الركبة ونقطة الكاحل.',
            },
            {
                title: 'نوع الساق',
                msg: 'الزاوية بين نقطة عظم الورك ومفصل الركبة ونقطة الكاحل في مقدمة الساقين اليسرى واليمنى.',
            },
            {
                title: 'ميل الحوض للأمام/للخلف',
                msg: 'الزاوية بين الخط العمودي والمستوى الناتج عن الشوكات الحرقفية الأمامية العلوية اليمنى واليسرى والارتفاق العاني.'
            },
            {
                title: 'تفاوت طول الساقين',
                msg: 'فرق الارتفاع عن الأرض بين أدنى نقطتين في الثنية الألوية اليمنى واليسرى.'
            }
        ],
        exception: [
            {
                title: 'يميل إلى الجانب الأيسر',
                abnormal: '',
            },
            {
                title: 'يميل إلى الجانب الأيمن',
                abnormal: '',
            },
            {
                title: 'عالية من اليسار ',
                abnormal: '',
            },
            {
                title: 'عالية من اليمين ',
                abnormal: '',
            },
            {
                title: 'إمالة الحوض الخلفية',
                abnormal: '',
            },
            {
                title: 'إمالة الحوض الأمامية',
                abnormal: '',
            },
            {
                title: 'فرط تمدد الركبة اليسرى',
                abnormal: '',
            },
            {
                title: 'الانحناء الأمامي للركبة اليسرى',
                abnormal: '',
            },
            {
                title: 'فرط تمدد الركبة اليمنى',
                abnormal: '',
            },
            {
                title: 'الانحناء الأمامي للركبة اليمنى',
                abnormal: '',
            },
            {
                title: 'أرجل على شكل حرف K',
                abnormal: '',
            },
            {
                title: 'أرجل على شكل حرف D',
                abnormal: '',
            },
            {
                title: 'أرجل على شكل حرف X',
                abnormal: '',
            },
            {
                title: 'أرجل على شكل حرف O',
                abnormal: '',
            },
            {
                title: 'إمالة الحوض الأمامية',
                abnormal: ''
            },
            {
                title: 'إمالة الحوض الخلفية',
                abnormal: ''
            },
            {
                title: 'انحراف في طول الساق اليسرى',
                abnormal: ''
            },
            {
                title: 'انحراف في طول الساق اليمنى',
                abnormal: ''
            }
        ],
    },
    newshape: {
        explain: [
            {
                msg: 'المسافة العمودية بين الأذنين وخط الجاذبية للجسم',
            },
            {
                msg: 'الزاوية بين الخط الواصل بين الأذنين والمستوى الأفقي',
            },
            {
                msg: 'المسافة العمودية بين النتوء الأخرمي الأيسر وخط الجاذبية',
            },
            {
                msg: 'المسافة العمودية بين النتوء الأخرمي الأيمن وخط الجاذبية',
            },
            {
                msg: 'الفرق بين خطي الربط بين قاعدة الرقبة والنتوءات الأخرمية على الجانبين',
            },
            {
                msg: 'المسافة العمودية بين مفصل الورك وخط الجاذبية للجسم',
            },
            {
                msg: 'الزاوية بين مفصل الكاحل ونقطة 1 سم أسفل مفصل الركبة اليسرى ومفصل الورك في المستوى السهمي',
            },
            {
                msg: 'الزاوية بين مفصل الكاحل ونقطة 1 سم أسفل مفصل الركبة اليمنى ومفصل الورك في المستوى السهمي',
            },
            {
                msg: 'الزاوية بين مفاصل الورك والركبة والكاحل الثنائية في المستوى الإكليلي',
            },
        ],
        item: {
            pelvis: 'الميل الأمامي للحوض',
        },
    },
    // 围度信息
    girth: {
        title: 'محيط الجسم',
        present: 'هذه المرة',
        noHistory: 'لا توجد بيانات',
        tpl: [
            {
                title: 'محيط الرقبة',
                key: 'قياس محيط الرقبة',
            },
            {
                title: 'محيط الذراع العلوي الأيسر',
                key: 'قياس محيط الذراع العلوي الأيسر',
            },
            {
                title: 'محيط الذراع العلوي الأيمن',
                key: 'قياس محيط الذراع العلوي الأيمن',
            },
            {
                title: 'محيط الصدر',
                key: 'قياس محيط الصدر',
            },
            {
                title: 'محيط خصر مرتفع',
                key: 'قياس محيط خصر مرتفع',
            },
            {
                title: 'محيط منتصف الخصر',
                key: 'قياس محيط منتصف الخصر',
            },
            {
                title: 'محيط الورك',
                key: 'قياس محيط الورك',
            },
            {
                title: 'محيط الفخذ الأيسر',
                key: 'قياس محيط الفخذ الأيسر',
            },
            {
                title: 'محيط وسط الفخذ الأيسر',
                key: 'قياس محيط وسط الفخذ الأيسر',
            },
            {
                title: 'الحد الأدنى لمحيط الفخذ الأيسر',
                key: 'الحد الأدنى لقياس محيط الفخذ الأيسر',
            },
            {
                title: 'محيط الفخذ الأيمن',
                key: 'قياس محيط الفخذ الأيمن',
            },
            {
                title: 'محيط وسط الفخذ الأيمن',
                key: 'قياس محيط وسط الفخذ الأيمن',
            },
            {
                title: 'الحد الأدنى لمحيط الفخذ الأيمن',
                key: 'الحد الأدنى لقياس محيط الفخذ الأيمن',
            },
            {
                title: 'محيط الساق اليسرى',
                key: 'قياس الساق اليسرى',
            },
            {
                title: 'محيط الساق اليمنى',
                key: 'قياس الساق اليمنى',
            },
            {
                title: 'محيط خصر منخفض',
                key: 'قياس محيط الخصر المنخفض',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: 'وظيفة الكتف',
        model: {
            val: 'قيمة القياس',
            scope: 'الحد الأقصى لموقع النشاط',
            diff: 'مقارنة بالسابق',
        },
        normal: 'لم يتم الكشف عن تشوهات ملحوظة.',
        normalAll: 'لم يتم الكشف عن أي تشوهات كبيرة في وظائف الكتف.',
        conclusion: 'استنتاج',
        analyse: 'تحليل:',
        suggest: 'اقتراح:',
        cause: 'يرجى طلب المشورة من الخبراء للحصول على التفاصيل.',
    },
    reportTips: {
        title: "هل تريد بالتأكيد حذف هذا التقرير؟ لن يمكن استرجاعه بعد الحذف.",
        confirm: "حذف",
        success: "تم حذف التقرير",
        partial: "تم حذف التقرير، وفشل مزامنة بعض البيانات، يرجى الاتصال بالمشرف.",
        failed: "فشل الحذف، يرجى إعادة المحاولة لاحقًا",
        btnMsg: 'حسنًا',
        alaryTips: 'تم حذف هذا التقرير من قبل المسؤول، سوف نقفز إلى التقرير التالي!',
    },
    saveQr: {
        title: 'تقرير الماسح الضوئي للجسم Visbody 3D',
        btnMsg: 'اضغط لفترة طويلة على الصورة لحفظها على هاتفك',
        tips: 'إذا وجدت أنه لا يمكنك الحفظ، يرجى الانتقال إلى [الإعدادات] وفتح الأذونات المقابلة',
    },
    'bodyPrediction': {
		'body-title': 'التنبؤ بشكل الجسم',
		'body-yu-ce-status': 'التنبؤ بناءً على حالتك الحالية',
		'body-setting': 'إعدادات تنبؤ الجسم',
		'body-li-xiang': 'القيمة المثالية:',
		'body-ti-zhong': 'الوزن',
		'body-ti-zhi-lv': 'نسبة الدهون',
		'body-ji-rou': 'كتلة العضلات',
		'yu-che-pre': 'قبل التنبؤ',
		'yu-che-after': 'بعد التنبؤ',
		'zan-model-no': 'لا يوجد نموذج',
		'ti-xing-error': 'فشل تركيب نتيجة التنبؤ~',
		'ti-xing-worker-error': 'يبدو أن سبب ذلك هو مشاكل في الشبكة~',
		'ti-xing-adjust': 'مقدار التعديل',
		'ji-rou-title': 'كتلة العضلات',
		'ti-zi-fang': 'دهون الجسم',
		'dang-pre-zhi': 'القيمة الحالية:',
		'nen-zhang': 'مستوى الدهون الحشوية',
		'nen-zhang-title': 'شرح منطقة الدهون الحشوية',
		'nen-zhang-title1': 'تتوزع الدهون الحشوية بين الأعضاء الداخلية، وتؤدي بسهولة إلى السمنة في منطقة البطن. تعرض منطقة الدهون الحشوية مساحة المقطع العرضي للدهون الحشوية.'
	},
    wifi: {
        'title': 'إعدادات Wi-Fi',
        'tips': 'يرجى إدخال كلمة المرور لشبكة Wi-Fi التالية',
        'password':'كلمة مرور Wi-Fi',
        'password-placeholder': 'يرجى إدخال كلمة مرور Wi-Fi',
        'password-tips': 'كلمة المرور حساسة لحالة الأحرف، يرجى التأكد من إدخالها بشكل صحيح',
        'button': 'إنشاء رمز QR',
        'h5-title': 'تكوين معلومات Wi-Fi',
        'wifi-name': 'اسم Wi-Fi:',
        'wifi-password': 'كلمة مرور Wi-Fi:',
        'wifi-qr-tips1': '* يرجى تأكيد صحة اسم وكلمة مرور Wi-Fi، ثم قم بمحاذاة رمز QR مع الكاميرا الموجودة أسفل الشاشة للمسح الضوئي.',
        'wifi-qr-tips2': 'قم بمحاذاة رمز الاستجابة السريعة (QR) الخاص بـ Wi-Fi مع الكاميرا أسفل الشاشة للمسح',
        'wifi-qr-button': 'رجوع',
    },
    vanCalendar: {
        end: 'End',
        start: 'Start',
        title: 'Calendar',
        startEnd: 'Start/End',
        weekdays: ['الأحد', 'الأثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthTitle: function monthTitle(year, month) {
            return month + '/' + year
        },
        rangePrompt: function rangePrompt(maxRange) {
            return 'Choose no more than ' + maxRange + ' days'
        },
    },
    share: {
        title: 'يرجى نسخ الرابط أدناه ومشاركته',
        btnMsg: 'نسخ',
    },
    waist: {
    "title": "قياس محيط الخصر والبطن",
    "hou":"خلف",
    "qian": "أمام"
  },
  "yao_wei_1": "منطقة الخصر",
  "yao_bu_fen_shu": "تقييم الخصر",
  "waist_fen": "النتيجة",
  "yao_wei": "محيط الخصر",
  "yao_wei_jian_ti_ji": "حجم بين محيطَي الخصر",
  "yao_tun_bi": "نسبة الخصر إلى الورك (WHR)",
  "lun_kuo_fen_xi": "تحليل الشكل الخارجي",
  "bei_bu": "منطقة الظهر",
  "tunbu": "منطقة الأرداف",
  "bei_bu_ti_ji": "حجم الظهر",
  "zheng_chang_fan_wei": "المدى الطبيعي:",
  "shang_ci": "السابقة ",
  "ben_ci": "الحالية ",
  "gupen": {
    "zheng_chang": "عادي",
    "qian_qin_yan_chang": "انحراف في الميل الأمامي",
    "qian_qin_yi": "احتمالية الميل الأمامي",
    "hou_qin_yi": "احتمالية الميل الخلفي",
    "hou_qin_yan_chang": "انحراف في الميل الخلفي",
    "zuo_chang_yan_chang": "انحراف في طول الساق اليسرى",
    "zuo_chang_yi": "احتمالية طول الساق اليسرى",
    "you_chang_yi": "احتمالية طول الساق اليمنى",
    "you_chang_yan_chang": "انحراف في طول الساق اليمنى"
  },
  "gao_yao_xian": "ارتفاع الخصر",
  "gao_yao_zhong_xian": "خط منتصف الخصر العالي",
  "gao_yao_xia_xian": "الخط السفلي للخصر العالي",
  "xiao_yao_shang_xian": "الخط العلوي للخصر المنخفض",
  "xiao_yao_zhong_xian": "خط منتصف الخصر المنخفض",
  "xiao_yao_xian": "خصر منخفض",
  "qv_jian1": "الجزء العلوي من الخصر العالي",
  "qv_jian2": "الجزء السفلي من الخصر العالي",
  "qv_jian_zhong": "منطقة وسط الخصر",
  "qv_jian3": "الجزء العلوي من الخصر المنخفض",
  "qv_jian4": "الجزء السفلي من الخصر المنخفض",
  "celiang.failed": "فشل القياس، يرجى ارتداء ملابس ضيقة والبقاء ثابتًا أثناء عملية القياس",
  "jie-gou-yi-chang-ping-gu": "تقييم التشوهات الهيكلية",
  "teng-tong-feng-xian-ping-gu": "تقييم مخاطر الألم",
  "zheng-chang": "عادي",
  "qing-du-yi-chang": "تشوه طفيف",
  "zhong-du2-yi-chang": "شذوذ متوسط",
  "zhong-du-yi-chang": "تشوه شديد",
  "pen-gu-zhuan-xiang-feng-xian-ping-gu": "تقييم مخاطر صحة الحوض",
  "qian-qing": "ميل أمامي",
  "hou-qing": "ميل خلفي",
  "xuan-zhuan": "دوران",
  "pen-gu-qian-qing-feng-xian-fen-shu": "درجة خطر ميل الحوض الأمامي",
  "pen-gu-hou-qing-feng-xian-fen-shu": "درجة خطر ميل الحوض الخلفي",
  "pen-gu-xuan-zhuan-feng-xian-fen-shu": "درجة خطر دوران الحوض",
  "fen": "نقاط",
  "gao-feng-xian": "خطر مرتفع",
  "ji-rou-ping-gu-jie-guo": "نتائج تقييم العضلات",
  "qian-qing-feng-xian-gao": "خطر مرتفع للميل الأمامي",
  "hou-qing-feng-xian-gao": "خطر مرتفع للميل الخلفي",
  "xuan-zhuan-feng-xian-gao": "خطر مرتفع للدوران",
  "qia-yao-ji-shu-ji-ji-xia-bu-jin-zhang-fu-heng-ji-bao-ruo": "شد في العضلة الحرقفية القطنية/الجزء السفلي من العضلة الناصبة للفقار، ضعف في العضلة البطنية المستعرضة.",
  "gu-hou-ji-qun-tun-ji-shu-ji-ji-jin-zhang-qia-yao-ji-ruo": "شد في أوتار الركبة، العضلات الألوية، والعضلة الناصبة للفقار؛ ضعف في العضلة الحرقفية القطنية.",
  "dan-ce-tun-zhong-ji-bao-ruo-yao-fang-ji-bu-ping-heng": "ضعف من جانب واحد في العضلة الألوية الوسطى / عدم توازن في العضلة المربعة القطنية.",
  "gu-pen-xiang-guan-ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan": "تقييم عضلات الحوض طبيعي. يرجى الاستمرار في الحفاظ على نمط حياة صحي.",
  "yi-shang-xiang-mu-jun-zheng-chang": "جميع العناصر المذكورة أعلاه طبيعية.",
  "ji-zhu-jie-gou-yi-chang-ping-gu": "تقييم التشوهات الهيكلية للعمود الفقري",
  "zheng-ti-ping-fen": "النتيجة الإجمالية",
  "jing-zhui": "الفقرات العنقية",
  "xiong-zhui": "الفقرات الصدرية",
  "yao-zhui": "الفقرات القطنية",
  "jing-zhui-jie-gou-yi-chang-ping-fen": "درجة تشوه هيكل الفقرات العنقية",
  "xiong-zhui-jie-gou-yi-chang-ping-fen": "درجة تشوه هيكل الفقرات الصدرية",
  "yao-zhui-jie-gou-yi-chang-ping-fen": "درجة تشوه هيكل الفقرات القطنية",
  "jing-zhui-ji-rou-ping-gu": "تقييم عضلات الفقرات العنقية",
  "xiong-zhui-ji-rou-ping-gu": "تقييم عضلات الفقرات الصدرية",
  "yao-zhui-ji-rou-ping-gu": "تقييم عضلات الفقرات القطنية",
  "ji-zhu-zheng-ti-pai-lie-ji-ben-zheng-chang": "المحاذاة العامة للعمود الفقري طبيعية.",
  "tou-bu-zi-tai-he-jing-zhui-pai-lie-ji-ben-zheng-chang": "وضعية الرأس ومحاذاة الفقرات العنقية ضمن الحدود الطبيعية.",
  "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "بروز/ميلان بالرأس وانحراف عنقي خفيف. انتبه لجلستك.",
  "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "بروز/ميلان بالرأس وانحراف عنقي. يُنصح بتصحيح القوام والتدريب.",
  "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "بروز/ميلان شديد وانحراف عنقي. يُنصح بتقييم وتدخل احترافي.",
  "xiong-zhui-pai-lie-ji-ben-zheng-chang-wu-ming-xian-jie-gou-yi-chang": "محاذاة الفقرات الصدرية طبيعية بشكل عام، مع عدم وجود تشوهات هيكلية كبيرة.",
  "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "انحراف صدري خفيف. يُنصح بتحسين إدارة القوام.",
  "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "انحراف صدري يؤثر على استقرار الجذع. يُنصح بتدريب موجه.",
  "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "انحراف صدري واضح وعدم تناسق. يُنصح بتصحيح احترافي.",
  "yao-zhui-pai-lie-zheng-chang-zi-shi-ping-heng-wu-ming-xian-jie-gou-yi-chang": "محاذاة الفقرات القطنية طبيعية مع قوام متوازن وبدون تشوهات هيكلية كبيرة.",
  "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "انحراف قطني خفيف، القوام متوازن. يُنصح بتدريب الجذع.",
  "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "انحراف قطني يؤثر على الاستقرار. يُنصح بتدريب تصحيحي.",
  "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "انحراف قطني واضح. يُنصح بخطة تحسين احترافية.",
  "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "فرط توتر: رافعة الكتف، SCM، وشبه المنحرفة العليا. ضعف: قابضات العنق العميقة. يُنصح بالاستقرار والاسترخاء.",
  "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "فرط توتر: SCM الأيسر والأخمعية الخلفية. ضعف: SCM الأيمن. يُنصح بتوازن الجانبين والاسترخاء.",
  "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "فرط توتر: SCM الأيمن. ضعف: SCM الأيسر والأخمعية الخلفية. يُنصح بالاستقرار المتماثل والاسترخاء.",
  "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "فرط توتر: شبه المنحرفة العليا اليسرى. ضعف: الوسطى/السفلى. يُنصح بالتدريب والاسترخاء.",
  "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "فرط توتر: مدورات الورك الداخلية والمقربات. ضعف: الألوية الوسطى. يُنصح بتدريب الألوية والإطالة.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "فرط توتر: الألوية الوسطى والكمثرية. ضعف: المقربات، المدورات الداخلية، و LCL. يُنصح باستقرار الساقين والاسترخاء.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "فرط توتر: الألوية الوسطى والكمثرية. ضعف أحادي: المقربات، المدورات الداخلية، و LCL. يُنصح بتدريب التوازن.",
  "jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "توصية: حافظ على توازن التدريب وتجنب الاستخدام المفرط من جانب واحد.",
  "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "فرط توتر: أوتار الركبة اليسرى والمأبضية. ضعف: العضلة الرباعية والنعلية. يُنصح بتدريب الرباعية/النعلية والإطالة.",
  "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "فرط توتر: الرباعية اليسرى. ضعف: الألوية الكبرى وأوتار الركبة. يُنصح بتدريب السلسلة الخلفية والإطالة.",
  "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "فرط توتر: أوتار الركبة اليمنى والمأبضية. ضعف: العضلة الرباعية والنعلية. يُنصح بتدريب الرباعية/النعلية والإطالة.",
  "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "فرط توتر: الرباعية اليمنى. ضعف: الألوية الكبرى وأوتار الركبة. يُنصح بتدريب السلسلة الخلفية والإطالة.",
  "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "انحراف فقري خفيف. انتبه للقوام ودرب الجذع.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "انحراف فقري متوسط. يُنصح بتدريب موجه.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-jiu-yi-jin-hang-duo-xue-ke-hui-zhen-ping-gu":"تشوه هيكلي شديد في العمود الفقري. يوصى باستشارة وتقييم طبي متعدد التخصصات الطبية.",
  "ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan": "تقييم العضلات طبيعي. يرجى الاستمرار في الحفاظ على نمط حياة صحي.",
  "teng-tong-qian-zai-feng-xian-ping-gu": "تقييم مخاطر الألم المحتملة",
  "jing-bu": "الرقبة",
  "bei-bu": "منطقة الظهر",
  "yao-bu": "منطقة الخصر",
  "jing-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "درجة الخطر المحتمل لألم الرقبة",
  "bei-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "درجة الخطر المحتمل لألم الظهر",
  "yao-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "درجة الخطر المحتمل لألم أسفل الظهر",
  "di-feng-xian": "خطر منخفض",
  "zhong-feng-xian": "خطر متوسط",
  "ji-zhu-jie-gou-ke-shi-hua": "عرض هيكل العمود الفقري",
  "tuo-dong-xuan-zhuan-shi-tu": "اسحب للتدوير",
  "ci-mo-xing-jin-gong-can-kao-shi-ji-ping-gu-yi-zhuan-ye-jian-ce-wei-zhun": "هذا النموذج مرجعي فقط. يرجى الرجوع إلى تقييم متخصص للتشخيص الفعلي.",
  "bei-mian": "الخلف",
  "zheng-shi-tu": "عرض أمامي",
  "you-shi-tu": "عرض أيمن",
  "hou-shi-tu": "عرض خلفي",
  "zuo-shi-tu": "عرض أيسر",
  "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "فرط توتر: شبه المنحرفة العليا اليمنى. ضعف: الوسطى/السفلى. يُنصح بالتدريب والاسترخاء.",
  "tun-xing": "شكل الأرداف",
  "dui-bi": "مقارنة",
  "fang-xing-tun": "شكل مربع",
  "li-xing-tun": "شكل كمثرى",
  "dao-san-jiao-xing-tun": "شكل V مقلوب",
  "yuan-xing-tun": "شكل دائري",
  "jiao-li-xiang": "شكل جيد",
  "mi-tao-tun": "شكل الخوخ",
  "ben-ci": "الحالي",
  "li-shi": "السجل",
  "ben-ci-li-shi": "الحالي، السجل",
  "tun-wei": "الورك",
  "tun-xing-shuo-ming": "حول أشكال الأرداف",
  "tun-xing-shi-zhi-ren-ti-hou-bei-bu-yu-da-tui-zhi-jian-de-bu-wei-suo-xing-cheng-de-qu-xian-he-xing-zhuang-tun-xing-ping-gu-ke-yi-bang-zhu-ren-men-geng-hao-di-shi-xian-xing-xiang-guan-li-he-jian-kang-guan-mai": "يشير شكل الأرداف إلى المنحنى والشكل للمنطقة بين أسفل الظهر والفخذين. يمكن أن يساعد هذا التقييم الأفراد على إدارة جمالياتهم الجسدية وصحتهم بشكل أفضل.",
  "wo-zhi-dao-le": "مفهوم",
  "fang-xing-tun-fang-xing-tun-shi-jue-gan-guan-shang-xia-yi-yang-kuan-tun-liang-ce-xian-tiao-jiao-zhi-mei-you-hu-du": "شكل مربع: يتميز شكل الأرداف المربع بعرض متماثل في الأعلى والأسفل، مع جوانب أكثر استقامة ومنحنيات أقل.",
  "yuan-xing-tun-shi-jue-gan-guan-xiang-yi-ge-yuan-xing-tun-bu-zhi-fang-fen-bu-jun-yun-yuan-run-bao-man-shi-fei-chang-li-xiang-de-tun-xing": "شكل دائري: يتميز هذا الشكل بتوزيع متساوٍ للدهون، مما يخلق مظهراً ممتلئاً ومتوازناً. يعتبر شكلاً مثالياً للأرداف.",
  "li-xing-tun-shi-jue-gan-guan-shang-zhai-xia-kuan-xia-tun-ji-rou-zhi-fang-fen-bu-jiao-duo-xian-tiao-bu-gou-feng-man": "شكل كمثرى: يتميز هذا الشكل بكونه أضيق من الأعلى وأوسع من الأسفل، مع تخزين المزيد من الدهون والعضلات في الجزء السفلي.",
  "dao-san-jiao-xing-tun-shi-jue-gan-guan-shang-kuan-xia-zhai-cheng-dao-san-jiao-xing": "شكل V مقلوب: يتميز هذا الشكل بكونه أوسع من الأعلى وأضيق نحو الأسفل، مشابهاً لمثلث مقلوب.",
  "mi-tao-tun-shi-jue-shang-xiang-yi-ge-mi-tao-xing-zhuang-tun-bu-xia-fang-feng-man-yao-bu-xian-xi-shi-fei-chang-li-xiang-de-tun-xing": "شكل الخوخ: هذا الشكل يشبه بصرياً الخوخ، ويتميز بالامتلاء في الجزء السفلي من الأرداف الذي يضيق نحو خصر أنحف. يعتبر شكلاً مثالياً.",
  "zan-wu-mo-xing": "لا يوجد نموذج متاح.",
  "ce-liang": "القياس",
  "ben-ci-ce-liang": "القياس الحالي",
  "ben-ci-ce-liang-wei-he-cheng-cheng-gong-ke-dao-she-bei-zai-ci-ce-liang": "فشل إنشاء النموذج للقياس الحالي. يرجى محاولة المسح مرة أخرى على الجهاز.",
  "gai-ri-qi-wu-mo-xing-qing-xuan-ze-qi-ta-dui-bi-ri-qi": "لا يوجد نموذج متاح لهذا التاريخ. يرجى تحديد تاريخ آخر للمقارنة.",
  "shou-ci-ce-liang-zan-wu-li-shi-shu-ju": "القياس الأول، لا توجد بيانات تاريخية متاحة.",
  "mo-xing-jia-zai-shi-bai-qing-shua-xin-ye-mian-chang-shi-yi-xia": "فشل تحميل النموذج. يرجى تحديث الصفحة والمحاولة مرة أخرى.",
  "jing-zhui-7": "C7 (الفقرة العنقية السابعة)",
  "di-gu-zhong-dian": "نقطة منتصف العجز",
  "di-gu-hou-shang-jiao": "الزاوية العلوية الخلفية للعجز",
  "ren-ti-zhong-xin": "مركز ثقل الجسم",
  "spine-tips1":"هذا التقرير مرجعي فقط ولا يجب استخدامه كأساس للتشخيص الطبي. يوصى بإجراء تقييم شامل بالتشاور مع الطبيب.",
  "spine-tips2": "2025 Visbody نظام تقييم صحة العمود الفقري",
  'tun-xing-ping-gu': 'تقييم شكل الأرداف',
  "yi-xia-shi-nin-de-tun-xing-lei-xing":"فيما يلي نوع شكل أردافك",
  "qi-ta-tun-xing": "أشكال الأرداف الأخرى",
  "ji-zhu-ping-gu": "تقييم العمود الفقري",
  "qing-shao-nian-ji-zhu-zhuan-xiang-feng-xian-ping-gu":"تقييم مخاطر صحة العمود الفقري للمراهقين",
  "qing-shao-nian-ji-zhu-fa-yu-zhi-shu": "مؤشر نمو العمود الفقري للمراهقين",
  "xue-xi-zi-shi-fu-he-zhi-shu": "مؤشر عبء وضعية الدراسة",
  "gu-ge-ping-heng-zhi-shu":"مؤشر توازن الهيكل العظمي",
  "sheng-chang-qi-teng-tong-yu-jing-zhi-shu": "مؤشر التحذير من آلام النمو",
  "ji-zhu-ce-wan-feng-xian-ping-fen": "درجة مخاطر الجنف",
  "qia-yao-ji-shu-ji-ji":"العضلة الحرقفية القطنية/العضلة الناصبة للفقار",
  "xia-bu-jin-zhang-fu-heng-ji-bao-ruo":"توتر في المنطقة السفلية، ضعف في العضلة البطنية المستعرضة",
  "ji-zhu-fa-yu-zheng-chang-wu-ming-xian-jie-gou-wen-ti":"نمو العمود الفقري طبيعي، لا توجد مشاكل هيكلية كبيرة.",
  "cun-zai-qing-wei-fa-yu-yin-huan-jian-yi-gai-shan-zi-shi-xi-guan":"توجد مخاطر طفيفة في النمو. يوصى بتحسين عادات القوام.",
  "zhong-du-fa-yu-feng-xian":"خطر متوسط في النمو.",
  "yan-zhong-ying-xiang-ji-zhu-fa-yu":"يؤثر بشدة على نمو العمود الفقري.",
  "xue-xi-zi-shi-liang-hao-ke-chang-shi-jian-wei-chi":"يؤثر بشدة على نمو العمود الفقري.",
  "zi-shi-you-dai-gai-shan-jian-yi-mei-45-fen-zhong-xiu-xi":"القوام بحاجة إلى تحسين. يوصى بأخذ استراحة كل 45 دقيقة.",
  "cun-zai-ming-xian-zi-shi-wen-ti-xu-yao-ding-qi-la-shen":"توجد مشاكل قوام كبيرة. يلزم الإطالة بانتظام.",
  "xue-xi-zi-shi-yan-zhong-bu-liang-huo-jiang-ying-xiang-xue-xi-xiao-shuai-he-fa-yu":"وضعية دراسة سيئة للغاية، مما قد يؤثر على كفاءة التعلم والنمو.",
  "gu-ge-fa-yu-dui-cheng-zi-shi-wen-ding":"نمو هيكل عظمي متماثل، قوام مستقر.",
  "cun-zai-qing-wei-bu-dui-cheng-jian-yi-jian-ce":"تم الكشف عن عدم تماثل طفيف. يوصى بالمراقبة.",
  "fa-yu-bu-jun-yun-xu-yao-jiu-zheng-cuo-shi":"نمو غير متساوٍ، يتطلب إجراءات تصحيحية.",
  "gu-ge-fa-yu-yan-zhong-bu-dui-cheng-ying-xiang-sheng-chang":"عدم تماثل شديد في الهيكل العظمي، يؤثر على النمو.",
  "zi-shi-liang-hao-teng-tong-feng-xian-di":"قوام جيد، وخطر ألم منخفض.",
  "qing-du-teng-tong-feng-xian-jian-yi-zi-shi-guan-li":"خطر ألم طفيف. يوصى بإدارة القوام.",
  "zhong-du-teng-tong-feng-xian-xu-zhuan-ye-zhi-dao":"خطر ألم متوسط، يتطلب توجيهاً متخصصاً.",
  "gao-du-teng-tong-feng-xian-ke-neng-yi-you-bu-shi-gan":"خطر ألم مرتفع، قد يكون هناك شعور بعدم الراحة بالفعل.",
  "di-feng-xian-qing-bao-chi-liang-hao-zi-shi-xi-guan":"خطر منخفض. يرجى الحفاظ على عادات قوام جيدة.",
  "zhong-feng-xian-ke-neng-xu-yao-jin-yi-bu-guan-cha-huo-gan-yu":"خطر متوسط. قد يتطلب الأمر مزيدًا من المراقبة أو التدخل.",
  "gao-feng-xian-xu-yao-ji-shi-jiu-yi-jin-hang-zhuan-ye-yi-liao-ping-gu-gan-yu":"خطر مرتفع. يرجى طلب تقييم وتدخل طبي متخصص في الوقت المناسب.",
  "you-liang":"ممتاز",
  "zhu-yi":"تنبيه",
  "gan-yu":"تدخل",
  "jing-shi":"تحذير",
  "di-fu-he":"عبء منخفض",
  "zhong-fu-he":"عبء متوسط",
  "gao-fu-he":"عبء مرتفع",
  "guo-zai":"حمل زائد",
  "ping-heng-xing":"متوازن",
  "qing-du-bu-ping-heng":"اختلال توازن طفيف",
  "zhong-du-bu-ping-heng":"اختلال توازن متوسط",
  "yan-zhong-bu-ping-heng":"اختلال توازن شديد",
  "an-quan":"آمن",
  "wei-xian":"خطر",
  "wu-yi-chang": "لا توجد مشكلات",
   balanceReport: {
        scoreUnit: 'نقاط',
        compareLast: 'مقارنة بالمرّة السابقة',
        status: {
            excellent: 'ممتاز',
            good: 'جيد',
            medium: 'متوسط',
            fair: 'متوسط',
            poor: 'ضعيف'
        },
        levelDesc: [
            'ممتاز',
            'جيد',
            'متوسط',
            'ضعيف'
        ],
        systemEvaluation: 'تقييم النظام الحسي',
        visualEvaluation: 'تقييم النظام الحسي البصري',
        evaluationLevel: 'مستوى التقييم',
        unit: 'وحدة القياس:',
        swayRms: 'مدى التذبذب (RMS)',
        eyeCloseTest: 'التوازن الثابت (العينان مغلقتان)',
        copArea: 'مساحة مسار مركز الضغط (COP)',
        avgSpeed: 'السرعة المتوسطة',
        maxDisplacement: 'الإزاحة القصوى',
        centerTrajectory: 'مسار حركة مركز الضغط (COP)',
        eyeOpenTest: 'التوازن الثابت (العينان مفتوحتان)',
        last: 'المرة الماضية ',
        conclusion: {
            eyeClose: {
                level1: 'توازن العينين المغلقتين: ممتاز (الدرجة A). تكامل حسي متقدم يضمن الثبات دون مدخلات بصرية، ويتيح الحركة بحرية في الظلام.',
                level2: 'توازن العينين المغلقتين: جيد (الدرجة B). تعويض جسدي-حسي فعال يسمح بتعديل الوضع دون مدخلات بصرية. الأنشطة اليومية طبيعية؛ قد يتطلب إغلاق العينين المفاجئ تعديلاً بسيطاً.',
                level3: 'توازن العينين المغلقتين: متوسط (الدرجة C). وظيفة حسية دون المستوى الأمثل تؤدي إلى تذبذبات أكبر. قد يشعر بعدم الاستقرار دون المساعدة البصرية وقد يحتاج إلى دعم إضافي.',
                level4: 'توازن العينين المغلقتين: ضعيف (الدرجة D). اضطرابات عصبية-حسية محتملة تجعل الحفاظ على التوازن صعبًا دون المساعدة البصرية. يزداد خطر السقوط في الظلام بشكل ملحوظ.'
            },
            eyeOpen: {
                level1: 'توازن العينين المفتوحتين: ممتاز (الدرجة A). تكامل بصري-حسي جسدي عالي الكفاءة يضمن وضعية مستقرة باستهلاك منخفض للطاقة. يتكيف جيدًا مع البيئات المعقدة.',
                level2: 'توازن العينين المفتوحتين: جيد (الدرجة B). يعتمد التحكم أساسًا على الارتجاع البصري، مع دعم من المدخلات الحسية الجسدية. يبقى مستقرًا أثناء الأنشطة اليومية.',
                level3: 'توازن العينين المفتوحتين: متوسط (الدرجة C). الوضعية غير مستقرة نسبيًا، مع صعوبة في استخدام المعلومات البصرية للحفاظ على التوازن. عرضة لعدم الاستقرار في البيئات المليئة بالمشتتات البصرية، ويتطلب تعديلات متكررة.',
                level4: 'توازن العينين المفتوحتين: ضعيف (الدرجة D). تذبذب واضح وضعف في استخدام المعلومات البصرية للحفاظ على التوازن. اضطرابات محتملة في التكامل الحسي. ضعف الاستقرار أثناء الأنشطة اليومية يزيد من خطر السقوط.'
            }
        },
        levelStatus: {
            A: 'الدرجة A',
            B: 'الدرجة B',
            C: 'الدرجة C',
            D: 'الدرجة D'
        },
        chart: {
            eyeCloseTest: 'اختبار الثبات (العينان مغلقتان)',
            eyeOpenTest: 'اختبار الثبات (العينان مفتوحتان)',
            yAxisLabels: ['منخفض', 'متوسط', 'مرتفع']
        },
        selectionRport: "اختر تقريرًا للمقارنة",
        measureDes: "تفاصيل القياسات حسب العنصر",
        balanceTittle: "تقييم التوازن",
        pingDes: "مستوى التقييم: ممتاز، جيد، مقبول، ضعيف"
    },
  ...arLocale,
  ...agrEn,
  "neckReport": {
  "title": "وظائف الرقبة",
  "conclusion": "تقييم وظائف الرقبة",
  "loading": "جارٍ إنشاء التقرير. يُرجى الانتظار.",
  "failed": "فشل التوليف.",
  "analysis": "تحليل",
  "suggestion": "اقتراح",
  "suggestionText": "ابحث عن متخصصين للفحص والعلاج المناسب"
}
}
